/* House of Modesty – navigation dropdown helper
   - hover a category: its dropdown opens straight away and stays open
     while the mouse moves down into it
   - click the small arrow: the dropdown stays open until a link is chosen,
     the customer clicks outside, clicks the arrow again, or presses Escape
   - keyboard: Tab opens the dropdown of the focused category, Escape closes
   - adds the arrow beside categories that have a dropdown
   - removes any old "▾" typed into menu titles */
(function () {
  'use strict';

  var CARET =
    '<span class="hom-caret" aria-hidden="true"><svg viewBox="0 0 10 6" focusable="false">' +
    '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  var CLOSE_DELAY = 300;
  var desktop = window.matchMedia('(min-width: 750px)');

  var openLi = null;
  var pinnedLi = null;
  var closeTimer = null;
  var keyboardMode = false;

  /* ---------- Tidy the menu titles ---------- */
  function stripArrowText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('▾') !== -1) {
        node.nodeValue = node.nodeValue.replace(/\s*▾\s*/g, '');
      }
    }
  }

  function addCarets(root) {
    var links = root.querySelectorAll('.menu-list__link[aria-haspopup]');
    for (var i = 0; i < links.length; i++) {
      var title = links[i].querySelector('.menu-list__link-title');
      if (title && !title.querySelector('.hom-caret')) {
        title.classList.add('hom-has-caret');
        title.insertAdjacentHTML('beforeend', CARET);
      }
    }
  }

  function tidy() {
    var header = document.getElementById('header-component');
    if (!header) return;
    stripArrowText(header);
    addCarets(header);
  }

  /* ---------- Helpers ---------- */
  function itemFrom(target) {
    return target && target.closest
      ? target.closest('#header-component .menu-list__list-item:not([slot="overflow"])')
      : null;
  }

  function submenuOf(li) {
    return li ? li.querySelector(':scope > .menu-list__submenu') : null;
  }

  function isDesktopMenu(li) {
    var header = li && li.closest('header-component');
    return !!header && desktop.matches && header.dataset.menuStyle === 'menu';
  }

  function setExpanded(li, value) {
    var link = li && li.querySelector('.menu-list__link[aria-haspopup]');
    if (link) link.setAttribute('aria-expanded', value ? 'true' : 'false');
  }

  /* Put the black box right under its category, flush with the header */
  function place(li) {
    var sub = submenuOf(li);
    if (!sub || !isDesktopMenu(li)) return;
    var header = li.closest('header-component');

    var parent = sub.offsetParent || header;
    var pr = parent.getBoundingClientRect();
    var lr = li.getBoundingClientRect();
    var hr = header.getBoundingClientRect();
    var viewport = document.documentElement.clientWidth;

    var left = lr.left - pr.left;
    var width = sub.offsetWidth;
    if (lr.left + width > viewport - 16) {
      left = Math.max(16, viewport - 16 - width) - pr.left;
    }

    sub.style.setProperty('--hom-left', left + 'px');
    sub.style.setProperty('--hom-top', hr.bottom - pr.top + 'px');
    sub.style.setProperty('--hom-bridge', Math.max(0, hr.bottom - lr.bottom) + 6 + 'px');
  }

  /* ---------- Open / close ---------- */
  function closeItem(li) {
    if (!li) return;
    li.classList.remove('hom-open');
    setExpanded(li, false);
    if (openLi === li) openLi = null;
    if (pinnedLi === li) pinnedLi = null;
  }

  function closeAll() {
    clearTimeout(closeTimer);
    clearTimeout(switchTimer);
    var items = document.querySelectorAll('#header-component .menu-list__list-item.hom-open');
    for (var i = 0; i < items.length; i++) closeItem(items[i]);
    openLi = null;
    pinnedLi = null;
  }

  function openItem(li) {
    clearTimeout(closeTimer);
    if (openLi && openLi !== li) {
      var prev = openLi;
      prev.classList.add('hom-shut');
      closeItem(prev);
      setTimeout(function () { prev.classList.remove('hom-shut'); }, 50);
    }
    if (pinnedLi && pinnedLi !== li) pinnedLi = null;
    openLi = li;
    li.classList.remove('hom-closed');
    if (submenuOf(li)) {
      place(li);
      li.classList.add('hom-open');
      setExpanded(li, true);
    }
  }

  function closeLater(li) {
    if (li === pinnedLi) return; // opened with the arrow: stays open
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { closeItem(li); }, CLOSE_DELAY);
  }

  /* ---------- Mouse hover ---------- */
  // When a dropdown was opened with the arrow, only switch to another
  // category if the mouse pauses on it (not just passes over it)
  var SWITCH_DWELL = 250;
  var switchTimer = null;

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var li = itemFrom(e.target);
    if (!li || !isDesktopMenu(li)) return;
    if (li.classList.contains('hom-closed')) return; // just closed: wait until the mouse leaves
    if (li === openLi) { clearTimeout(closeTimer); clearTimeout(switchTimer); return; }
    if (pinnedLi && pinnedLi !== li) {
      clearTimeout(switchTimer);
      switchTimer = setTimeout(function () { openItem(li); }, SWITCH_DWELL);
      return;
    }
    openItem(li);
  });

  document.addEventListener('pointerout', function (e) {
    var li = itemFrom(e.target);
    if (!li || li.contains(e.relatedTarget)) return;
    if (li !== openLi) clearTimeout(switchTimer);
    if (li === openLi) closeLater(li);
  });

  document.addEventListener('pointerdown', function () { keyboardMode = false; }, true);

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target;

    // Click on the arrow: keep the dropdown open (or close it if already kept open)
    var caret = target.closest && target.closest('#header-component .hom-caret');
    if (caret) {
      var li = itemFrom(caret);
      if (li && isDesktopMenu(li)) {
        clearTimeout(switchTimer);
        e.preventDefault();
        e.stopPropagation();
        if (pinnedLi === li) {
          closeItem(li);
          li.classList.add('hom-closed'); // stay shut until the mouse leaves
        } else {
          openItem(li);
          pinnedLi = li;
        }
        return;
      }
    }

    // Choosing a link closes the menu
    var itemLi = itemFrom(target);
    if (itemLi && target.closest('.mega-menu__link')) {
      closeAll();
      return;
    }

    // Click anywhere outside the open menu closes it
    if (openLi && !openLi.contains(target)) closeAll();
  }, true);

  /* ---------- Keyboard ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') keyboardMode = true;
    if (e.key !== 'Escape') return;
    var li = itemFrom(document.activeElement) || openLi;
    if (!li) return;
    closeItem(li);
    li.classList.add('hom-closed');
    var top = li.querySelector('.menu-list__link');
    if (top && li.contains(document.activeElement)) top.focus();
  });

  document.addEventListener('focusin', function (e) {
    var li = itemFrom(e.target);
    if (!li || !isDesktopMenu(li)) return;
    if (keyboardMode && !li.classList.contains('hom-closed')) openItem(li);
  });

  document.addEventListener('focusout', function (e) {
    var li = itemFrom(e.target);
    if (!li || li.contains(e.relatedTarget)) return;
    li.classList.remove('hom-closed');
    if (keyboardMode && li !== pinnedLi) closeItem(li);
  });

  // Mouse leaving the category clears an Escape/arrow "keep shut" state
  document.addEventListener('pointerout', function (e) {
    var li = itemFrom(e.target);
    if (li && !li.contains(e.relatedTarget)) li.classList.remove('hom-closed');
  });

  /* ---------- Start ---------- */
  function start() {
    tidy();
    var header = document.getElementById('header-component');
    if (header) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          tidy();
        });
      }).observe(header, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
